import { Box } from '@mui/material';
import { Navigation } from './Navigation';

interface LandingLayoutProps {
  children: React.ReactNode;
}

export function LandingLayout({ children }: LandingLayoutProps) {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Navigation />
      <Box component="main" sx={{ pt: 8 }}> {/* Add padding-top to account for fixed navbar */}
        {children}
      </Box>
    </Box>
  );
} 